import * as angular from 'angular';

export default [
  '$stateProvider',
  '$urlRouterProvider',
  '$httpProvider',
  '$locationProvider',
  'cfpLoadingBarProvider',
  '$translateProvider',
  '$compileProvider',
  '$qProvider',
  'intlTelInputOptions',
  'StripeElementsProvider',
  '$provide',
  (
    $stateProvider,
    $urlRouterProvider,
    $httpProvider,
    $locationProvider,
    cfpLoadingBarProvider,
    $translateProvider,
    $compileProvider,
    $qProvider,
    intlTelInputOptions,
    StripeElementsProvider,
    $provide
  ) => {
    $compileProvider.debugInfoEnabled(false);
    $compileProvider.commentDirectivesEnabled(false);
    $compileProvider.cssClassDirectivesEnabled(false);
    $qProvider.errorOnUnhandledRejections(false);
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|file|blob):/);

    $locationProvider.html5Mode({ enabled: true, requireBase: false });
    cfpLoadingBarProvider.includeSpinner = false;
    // $urlRouterProvider.otherwise('/');
    $translateProvider
      .useLoaderCache(true)
      .forceAsyncReload(true)
      .useSanitizeValueStrategy(null)
      .determinePreferredLanguage();

    $provide.value('$translateProvider', $translateProvider);

    $httpProvider.interceptors.push([
      '$rootScope',
      '$q',
      '$translate',
      'Toast',
      ($rootScope, $q, $translate, Toast) => {
        return {
          responseError: res => {
            if (!res.config.ignoreInterceptor) {
              if (res.status === 401) $rootScope.$emit('UNAUTHORIZED');
              else if (res.status === 403) Toast.warning('FORBIDDEN', 'ERROR_403');
              else if (res.status === 404) Toast.warning('NOT_FOUND', 'ERROR_404');
              else if (res.status >= 400) {
              // TODO: needed until Harvest is used in case Harvest error,
                if (res.data && res.data.length && res.data[0].indexOf('{') >-1) {
                  const message = JSON.parse(res.data[0]).message;
                  const uniqueMessage = message === 'Name has already been taken' ? 'PLANS.CARD_NAME_HARVEST_ERROR' : message;
                  Toast.error(uniqueMessage);
                } else {
                  Toast.error(res.data);
                }
              }
              return $q.reject(res);
            } else {
              return $q.reject(res);
            }
          }
        };
      }
    ]);

    $stateProvider
      .state('app', {
        abstract: true,
        component: 'app',
        resolve: {
          bootstrap: ['BootstrapService', BootstrapService => BootstrapService.fullAppState(StripeElementsProvider)]
        }
      })
      .state('accounts', {
        abstract: true,
        component: 'app',
        resolve: {
          bootstrap: ['BootstrapService', BootstrapService => BootstrapService.chooseAccountState()]
        }
      })
      .state('blocked', {
        abstract: true,
        component: 'app',
        resolve: {
          bootstrap: ['BootstrapService', BootstrapService => BootstrapService.blockedState(StripeElementsProvider)]
        }
      });

    angular.extend(intlTelInputOptions, {
      customPlaceholder: function() {
        return 'Phone number';
      }
    });
  }
];
